<highcharts-chart [Highcharts]="chart" [options]="chartOptions"
                  [style]="'width: '+width+'; height: '+height+'; display: block;'"></highcharts-chart>
